const LoginOrdersfileDownload = (file) => {
  const blob = new Blob([file], {
    type: "application/vnd.ms-excel;charset=utf-8",
  });

  const today = new Date();
  const date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  const timestamp = date + " " + time;
  const fileName = "LoginOrdersReport" + timestamp + ".xlsx";
  if ("download" in document.createElement("a")) {
    //Non ie Download
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // release the URL object
    document.body.removeChild(elink);
  } else {
    //Ie10 + download
    navigator.msSaveBlob(blob, fileName);
  }
};

export { LoginOrdersfileDownload };
